import React from "react";
import { Typography, useBreakpoint } from "@one-thd/sui-atomic-components";
import { MILITARY_BANNER_CONFIG } from "./militaryBannerConfig";

const MilitaryBanner = () => {
  const { greater: isDesktop } = useBreakpoint("sm");
  const { greater: isXl } = useBreakpoint("xl");

  const bannerStyles: React.CSSProperties = {
    backgroundColor: MILITARY_BANNER_CONFIG.backgroundColor,
  };

  const message: string = MILITARY_BANNER_CONFIG.message;

  return (
    <div
      className="sui-flex sui-flex-row sui-gap-2 sui-items-center sui-justify-start"
      role="banner"
      data-component="MilitaryBanner"
      aria-label="Military service banner"
    >
      {/* Logo Section */}
      <img
        src={MILITARY_BANNER_CONFIG.logo.src}
        alt={MILITARY_BANNER_CONFIG.logo.alt}
        height="auto"
        width={isXl ? "5.5%" : MILITARY_BANNER_CONFIG.logo.width}
        className="sui-object-contain"
        data-testid="military-banner-logo"
      />
      {/* Message Section */}
      <div
        className={`sui-px-3 ${isDesktop ? "sui-py-4 sui-w-full" : "sui-pb-2 sui-pt-1"}`}
        style={bannerStyles}
        data-testid="military-banner-message-section"
      >
        <Typography
          variant={isDesktop ? "h3" : "h4"}
          weight="display"
          color="inverse"
          className="sui-text-left"
          data-testid="military-banner-message"
        >
          {message}
        </Typography>
      </div>
    </div>
  );
};

MilitaryBanner.displayName = "MilitaryBanner";

export { MilitaryBanner };
